import React from 'react';
import LayoutResolver from "./components/layout/LayoutResolver";

export const HomeRouter = ({ forceView, ...rest }) => (
    <LayoutResolver {...rest} />
)
